import { types } from 'mobx-state-tree';
import CreditCard from '../types/CreditCard';

export default types
  .model('PaymentMethodForm', {
    requestInProgress: false,
    wasSuccessful: false,
    wasSubmitted: false,
    error: types.maybeNull(types.string),
    creditCard: types.optional(CreditCard, {}),
  })
  .views(self => ({
    get hasError() {
      return !!self.error;
    },
    get hasAddressError() {
      return !self.creditCard.address.hasAddress && self.wasSubmitted;
    },
  }))
  .actions(self => {
    let hasClearedNumber = false;
    return {
      setIsRequesting(state = true) {
        self.requestInProgress = state;
        return self;
      },
      setError(message) {
        self.error = message;
        return self;
      },
      setAddress(address) {
        self.address = address;
        return self;
      },
      clearError() {
        self.error = null;
        return self;
      },
      setWasSuccessful(wasSuccessful = true) {
        self.wasSuccessful = wasSuccessful;
        return self;
      },
      setWasSubmitted(wasSubmitted = true) {
        self.wasSubmitted = wasSubmitted;
        return self;
      },
      clearNumber() {
        if (!hasClearedNumber) {
          self.creditCard.setNumber('');
          hasClearedNumber = true;
        }
      },
    };
  });
